/**
 * DescriptionTip component.
 */
import Container from '@components/atoms/container/descriptionTipContainer';
import Tip from '@components/elements/tip/tip';

/**
 * Accessibility / hint row above the event title.
 */
export default function DescriptionTip() {
  return (
    <Container>
      <Tip />
    </Container>
  );
}
